import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import onClickOutside from 'react-onclickoutside'
import mousetrap from 'mousetrap'

import classNames from './GenericAutocomplete.css'
import Icon from './Icon'
import { matchString } from '../utils/string'

class GenericAutocomplete extends Component {
  static defaultProps = {
    limit: 20,
    minLength: 2
  }
  state = {
    showSuggestions: false,
    selected: -1
  }
  componentDidMount () {
    this.node = findDOMNode(this)
    mousetrap.bind('up', this.onKeyUp)
    mousetrap.bind('down', this.onKeyDown)
    mousetrap.bind('escape', () => {
      this.clearSearch()
    })
  }
  componentDidUpdate (prevProps, prevState) {
    const { selected } = this.state
    if (prevState.selected !== selected) {
      const button = this.node.querySelectorAll('.' + classNames.autoCompleteButton)[selected]
      button && button.focus()
    }
  }
  componentWillUnmount () {
    mousetrap.unbind(['up', 'down', 'escape'])
  }
  onKeyDown = e => {
    e.preventDefault()
    this.setState({ selected: this.state.selected + 1 })
  }
  onKeyUp = e => {
    e.preventDefault()
    if (this.state.selected === 0) {
      this.refs.input.focus()
    }
    this.setState({ selected: Math.max(-1, this.state.selected - 1) })
  }
  handleClickOutside = () => {
    this.setState({
      showSuggestions: false,
      selected: -1
    })
  }
  selectSuggestion = item => {
    const { onChange, onSelect } = this.props
    if (onSelect) {
      onSelect(item)
    } else {
      onChange(item)
    }
    this.setState({
      showSuggestions: false,
      selected: -1
    })
  }
  showSuggestions = () => {
    this.setState({
      showSuggestions: true
    })
  }
  clearSearch = () => {
    this.props.onChange('')
    this.refs.input.focus()
  }
  onChangeText = e => {
    this.props.onChange(e.target.value)
    this.setState({
      selected: -1
    })
  }
  renderSuggestion = item => {
    return (
      <li key={item.id} className={classNames.autoCompleteItem}>
        <button onClick={() => this.selectSuggestion(item)} className={classNames.autoCompleteButton}>
          {item.value || item.keyword}
        </button>
      </li>
    )
  }
  renderSuggestions = () => {
    const { value, suggestions, limit } = this.props

    const groups = suggestions.map(group => {
      return {
        title: group.title,
        items: group.items.filter(item => {
          return matchString(value, item.value || item.keyword, true)
        }).slice(0, limit)
      }
    })

    return (
      <ul className={classNames.autoComplete}>
        {
          groups.map(group => {
            if (group.items.length === 0) {
              return null
            }
            return [
              <li key='heading' className={classNames.autoCompleteHeading}>
                {group.title}
              </li>,
              group.items.map(this.renderSuggestion)
            ]
          })
        }
      </ul>
    )
  }
  render () {
    const { value, placeholder, minLength } = this.props
    const { showSuggestions } = this.state

    return (
      <div className={classNames.wrapper} style={this.props.style}>
        <input
          type='text'
          ref='input'
          value={value}
          onChange={this.onChangeText}
          onFocus={this.showSuggestions}
          className={'mousetrap ' + classNames.input}
          placeholder={placeholder}
        />
        {value !== '' &&
          <button onClick={this.clearSearch} className={classNames.clearButton}>
            <Icon icon='close' />
          </button>
        }
        {showSuggestions && value.length >= minLength &&
          this.renderSuggestions()
        }
      </div>
    )
  }
}

export default onClickOutside(GenericAutocomplete)



// WEBPACK FOOTER //
// ./src/components/GenericAutocomplete.js